import ApplicationController from './application_controller'
import copy from "copy-to-clipboard";
import '~/stylesheets/copytoclipboard.css'

export default class extends ApplicationController {

  static targets = [ "input", "button" ]

  connect () {
    super.connect()
    console.log("copytoclipboard_controller.js connected")
  }

  copyText (event) {
    console.log(this.inputTarget.value);
    copy(this.inputTarget.value);
    // this.inputTarget.select();
    // this.inputTarget.setSelectionRange(0, 99999); // For mobile devices

    //navigator.clipboard.writeText(this.inputTarget.value)
    console.log("Input data copied to clipboard successfully '" + this.inputTarget.value + "'");
  }
}
